import request from '@/utils/request'
import { INewsData } from './types'
export const defaultNewsData: INewsData = {
  id: 0,
  title: '',
  createTime: '',
  updateTime: '',
  keywords: '',
  info: '',
  content: '',
  submitStatus: 0,
  isExistHtml: 0,
  imgPath: ''
}
export const selectNewsInfo = (params: any) =>
  request({
    url: '/news/selectNewsInfo',
    method: 'get',
    params
  })
export const insertNewsInfo = (data: any) =>
  request({
    url: '/news/insertNewsInfo',
    method: 'post',
    data
  })
export const updateNewsInfo = (data: any) =>
  request({
    url: '/news/updateNewsInfo',
    method: 'post',
    data
  })
export const deleteNewsInfo = (id: number) =>
  request({
    url: '/news/deleteNewsInfo/' + id,
    method: 'delete'
  })

export const searchNewsInfo = (params: any) =>
  request({
    url: '/news/searchNewsInfo',
    method: 'get',
    params
  })
